import { BlockComponentFactory } from 'shared/express-interface/blocks-core/BlockFactory'

type ButtonBlockProps = {
    text: string
    onClick: () => void
}

export const ButtonBlockComponent = BlockComponentFactory.createBlockComponent<ButtonBlockProps>(
    props => {
        return (
            <button style={props.style} onClick={props.onClick}>
                {props.text}
            </button>
        )
    }
)
